import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Button } from '../General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { ButtonWithRequest } from './ButtonWithRequest';
import { TableTd } from '../General/Table';

interface Props {
  price: string;
  unit: string;
  addToRequest: any;
  addToCart: any;
  showPriceIfNotOnStock?: boolean;
  noStock: boolean;
  fontSize?: number;
  oldPrice?: number;
  isInCart?: boolean;
}

function ProductPriceCartTable({
  price,
  unit,
  addToCart,
  addToRequest,
  noStock,
  fontSize = 14,
  oldPrice,
  isInCart,
}: Props) {
  return (
    <>
      <PriceTableTd fontSize={fontSize} align={'right'}>
        {price ? `${price} € / ${unit}` : ''}
        <OldPrice>
          {oldPrice ? `${oldPrice.toFixed(2)} € / ${unit}` : ''}
        </OldPrice>
      </PriceTableTd>
      <ButtonTableTd>
        <ButtonWithRequest
          onButtonClick={addToCart}
          onRequestClick={addToRequest}
          noStock={noStock}
          isInCart={isInCart}
        />
      </ButtonTableTd>
    </>
  );
}

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.placeholder};
`;

const OldPrice = styled(SecondaryText)`
  text-decoration: line-through;

  ${({ theme }) => theme.mediab.m760`
    display: none;
  `}
`;

const PriceTableTd = styled(TableTd)<{ fontSize: number }>`
  padding: ${rem(24)} 0 ${rem(16)};
  border-bottom: ${({ theme }) => theme.borders.primary};
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${({ fontSize }) => rem(fontSize)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(6)};
  white-space: nowrap;
`;

const ButtonTableTd = styled(TableTd)`
  padding: ${rem(24)} 0 ${rem(16)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

export { ProductPriceCartTable };
